module.exports = __webpack_public_path__ + "static/media/English - Teaching - Road to Enlightenment (load_3) - translated by JL.1496f620.txt";